/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PatientDemographic } from '../models/patient-demographic';
import { patientDemographicsGetById } from '../fn/patient-demographics/patient-demographics-get-by-id';
import { PatientDemographicsGetById$Params } from '../fn/patient-demographics/patient-demographics-get-by-id';
import { patientDemographicsUpdate } from '../fn/patient-demographics/patient-demographics-update';
import { PatientDemographicsUpdate$Params } from '../fn/patient-demographics/patient-demographics-update';

@Injectable({ providedIn: 'root' })
export class PatientDemographicsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `patientDemographicsGetById()` */
  static readonly PatientDemographicsGetByIdPath = '/api/PatientDemographics/{patientId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientDemographicsGetById()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientDemographicsGetById$Response(params: PatientDemographicsGetById$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientDemographic>> {
    return patientDemographicsGetById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientDemographicsGetById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientDemographicsGetById(params: PatientDemographicsGetById$Params, context?: HttpContext): Observable<PatientDemographic> {
    return this.patientDemographicsGetById$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientDemographic>): PatientDemographic => r.body)
    );
  }

  /** Path part for operation `patientDemographicsUpdate()` */
  static readonly PatientDemographicsUpdatePath = '/api/PatientDemographics/{patientId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientDemographicsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patientDemographicsUpdate$Response(params: PatientDemographicsUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return patientDemographicsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientDemographicsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patientDemographicsUpdate(params: PatientDemographicsUpdate$Params, context?: HttpContext): Observable<Blob> {
    return this.patientDemographicsUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
